import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["photo"]
  static values = { sortableUrl: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: '.drag-handle',
      animation: 150,
      ghostClass: 'photo-ghost',
      chosenClass: 'photo-chosen',
      dragClass: 'photo-drag',
      filter: '.add-photos-card',
      onEnd: this.reorder.bind(this),
    })
  }

  reorder(event) {
    const photoElements = this.photoTargets
    const orderedIds = photoElements.map(el => el.dataset.photoId)

    fetch(this.sortableUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ ordered_ids: orderedIds })
    }).then(response => {
      if (response.ok && response.headers.get("content-type")?.includes("turbo-stream")) {
        return response.text()
      } else if (!response.ok) {
        console.error("Failed to update photo order.")
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    })
  }
}